import React from 'react';
import { AboutPageLayout } from '../Layout';
import styles from './What.module.scss';

export const WhatMainSection = () => (
  <AboutPageLayout
    isMain
    leftContent={
      <div className={styles.leftSection}>
        <div className={styles.mainSection_1}>Wh</div>
        <div className={styles.mainSection_2}>at is</div>
        <div className={styles.mainSection_3}>TransparenTerra?</div>
      </div>
    }
    rightContent={null}
  />
);
